// https://developer.mozilla.org/en-US/docs/Web/API/Touch_events

/////////////////////////////////////////////////////////////////////////
// Globals
var gMaxPathCount = 5; // potentially 5 fingers
/////////////////////////////////////////////////////////////////////////

// TODO not fully implemented yet
class TouchPoint {
    constructor(x, y, pathId) {
        this.x_ = x;
        this.y_ = y;

        this.id_ = pathId; // for debugging
    }
}

class TouchPath {
    constructor(id) {
        this.id_ = id;
        this.pathPoints_ = [];
        this.currentPathIndex_ = 0;
    }

    setId(id) {
        this.id_ = id;
    }

    getId() {
        return this.id_;
    }

    resetPath() {
        this.pathPoints_.length = 0;
    }

    addPoint(p) {
        this.pathPoints_.push(p);
    }
}

// we only handle single touch path
class TouchEventHandler {
    constructor() {
        this.width_ = 1;
        this.height_ = 1;

        this.isDown_ = false;

        this.screenX_ = 0;
        this.screenY_ = 0;
        this.clientX_ = 0;
        this.clientY_ = 0;

        this.lastX_ = 0;
        this.lastY_ = 0;

        this.deltaX_ = 0.0;
        this.deltaY_ = 0.0;

        this.normX_ = 0.0;
        this.normY_ = 0.0;

        this.inside_ = false;
    }

    isDown() {
        return this.isDown_;
    }

    getDeltaX() {
        return this.deltaX_;
    }
    getDeltaY() {
        return this.deltaY_;
    }

    getNormX() {
        return this.normX_;
    }
    getNormY() {
        return this.normY_;
    }

    resetMouseState() {
        this.flush();
        this.screenX_ = 0;
        this.screenY_ = 0;
        this.clientX_ = 0;
        this.clientY_ = 0;
        this.lastX_ = 0;
        this.lastY_ = 0;
        this.deltaX_ = 0.0;
        this.deltaY_ = 0.0;

        this.normX_ = 0.0;
        this.normY_ = 0.0;
        this.isDown_ = false;
        this.startNewPath_ = false;
    }

    flush() {
        this.deltaX_ = 0.0;
        this.deltaY_ = 0.0;
    }

    onTouchStart(event) {
        this.isDown_ = true;
        this.startNewPath_ = true;
        console.log("Touch down");
        event.preventDefault();
    }

    onTouchEnd(event) {
        this.isDown_ = false;
        console.log("Touch up");
        event.preventDefault();
    }

    onTouchCancel(event) {
        if (event.touches.length > 1) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
        this.isDown_ = false;
        event.preventDefault();
    }

    onTouchMove(event) {
        var touchObj = event.changedTouches[0];
        this.screenX_ = touchObj.screenX;
        this.screenY_ = touchObj.screenY;
        this.clientX_ = touchObj.clientX;
        this.clientY_ = touchObj.clientY;

        //  console.log("client:" + this.clientX_ + "," + this.clientY_);
        let rect = touchObj.target.getBoundingClientRect();
        this.width_ = rect.right - rect.left;
        this.height_ = rect.bottom - rect.top;

        if (this.inside_) {
            if (this.startNewPath_) {
                this.lastX_ = this.clientX_;
                this.lastY_ = this.clientY_;
                this.startNewPath_ = false;

                console.log("delta:" + this.deltaX_ + "," + this.deltaY_);
            }
            this.deltaX_ = (this.clientX_ - this.lastX_) / this.width_;
            this.deltaY_ = (this.clientY_ - this.lastY_) / this.height_;
        }

        // Check if the mouse cursor is in canvas.
        if (
            this.clientX_ >= rect.left &&
            this.clientX_ < rect.right &&
            this.clientY_ >= rect.top &&
            this.clientY_ < rect.bottom
        ) {
            this.lastX_ = this.clientX_;
            this.lastY_ = this.clientY_;
            this.inside_ = true;
            this.normX_ = this.clientX_ / (rect.right - rect.left);
            this.normY_ = 1.0 - this.clientY_ / (rect.bottom - rect.top);
        } else {
            this.inside_ = false;
        }
        event.preventDefault();
    }
}

export { TouchEventHandler };
